<template>
    <div :class="['row', 'account', 'call-to-action']">
        <div class="cta-content">
            <div class="left">
                <div class="title h5">{{ $t('views.accounts.ctas.pp.title') }}</div>
                <div class="description p">{{ $t('views.accounts.ctas.pp.description') }}</div>
            </div>
            <div class="right">
                <button class="btn-5 btn-s" @click="createAccountPopup">{{ $t('views.accounts.ctas.pp.button') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import i18n from "@/plugins/i18n";
    import { usePopupStore } from '@/stores/utils/popup';
    import { useToastStore } from '@/stores/utils/toast';
    import AccountCreateForm from '@/components/forms/AccountCreateForm';
    import { markRaw } from 'vue';

    export default {
        name: 'AccountsListItemCreate',
        computed: {
            popupStore() {
                return usePopupStore();
            },
            toastStore() {
                return useToastStore();
            }
        },
        methods: {
            createAccountPopup() {
                this.popupStore.showPopup('form', {
                    title: 'popups.create_account.title',
                    description: 'popups.create_account.description',
                    formComponent: markRaw(AccountCreateForm),
                    onFormSuccess: () => {
                        this.toastStore.addToast(i18n.global.t('toasts.success.account_created'), 'success');
                    }
                });
            }
        },
    };
</script>